import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardService } from '../../shared/services/dashboard.service'; // Assuming this is your http wrapper

export interface CreateAlertPayload {
  deviceId: string;
  parameter: string;
  min: string;
  max: string;
  email: string;
}

@Injectable({
  providedIn: 'root'
})
export class EmailAlertService {

  constructor(private apiService: DashboardService) { } // Renamed for clarity

  // Device Hierarchy fetch karne ke liye
  getDeviceLocationHierarchy(): Observable<any> {
    const body = {
      action: 'getDeviceLocationHierarchy',
      account_id: localStorage.getItem('account')
    };
    return this.apiService.httpPost(body);
  }

  // Pehle se bani hui alerts fetch karne ke liye
  getEmailAlerts(): Observable<any> {
    const body = {
      action: 'getEmailAlerts',
      user_id: localStorage.getItem('user')
    };
    return this.apiService.httpPost(body);
  }

  // Device ID se uske parameters fetch karne ke liye
  getParametersByDeviceId(deviceId: string): Observable<any> {
    const body = {
      action: 'getDeviceByID',
      device_id: [deviceId]
    };
    return this.apiService.httpPost(body);
  }

  // Alert banane ya update karne ke liye
  createOrUpdateEmailAlert(payload: CreateAlertPayload): Observable<any> {
    const body = {
      action: 'createOrUpdateEmailAlerts',
      user_id: localStorage.getItem('user'),
      device_id: payload.deviceId,
      email: payload.email,
      min: payload.min,
      max: payload.max,
      parameter: payload.parameter
    };
    return this.apiService.httpPost(body);
  }
}